export default {
  'oper-logs.query.title': '操作模块',
  'oper-logs.query.title.placeholder': '请输入操作模块',
  'oper-logs.query.businessType': '业务类型',
  'oper-logs.query.businessType.placeholder': '请选择业务类型',
  'oper-logs.query.operName': '操作人名称',
  'oper-logs.query.operName.placeholder': '请输入操作人名称',
  'oper-logs.query.status': '操作状态',
  'oper-logs.query.status.placeholder': '请选择操作状态',
  'oper-logs.query.status.success': '成功',
  'oper-logs.query.status.fail': '失败',
  'oper-logs.column.expand.reqUrl': '请求url',
  'oper-logs.column.expand.reqMethod': 'HttpMethod',
  'oper-logs.column.expand.reqParams': '请求参数',
  'oper-logs.column.expand.method': '执行方法',
  'oper-logs.column.expand.respResult': '响应结果',
  'oper-logs.column.expand.deptName': '操作人部门',
  'oper-logs.column.expand.errorMsg': '异常消息',
  'oper-logs.column.expand.errorMsg.view': '查看异常堆栈',
  'oper-logs.column.title': '操作模块',
  'oper-logs.column.businessType': '业务类型',
  'oper-logs.column.operName': '操作人',
  'oper-logs.column.reqIp': '请求IP',
  'oper-logs.column.reqRegion': '请求地域',
  'oper-logs.column.browser': '浏览器',
  'oper-logs.column.os': '操作系统',
  'oper-logs.column.status': '操作结果',
  'oper-logs.column.status.success': '成功',
  'oper-logs.column.status.fail': '失败',
  'oper-logs.column.createTime': '操作时间',
  'oper-logs.dialog.title': '异常堆栈',
  'oper-logs.dialog.noContent': '暂无堆栈信息',
}
